module.exports = __webpack_public_path__ + "202408221624/img/home_case_4.79d86475.jpg";